





































import { Component, Prop, Vue } from "../vuepack";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import Button from "@/shared/components/ui/Button.vue";
import { RawLocation } from "vue-router";
import { useNotifierStore } from "@/shared/store/notifier";
import { useBiometricAuthStore } from "@/shared/store/biometricAuth";

@Component({
  components: {
    LoginWrapper,
    Button,
  },
})
export default class BiometricAuthSetup extends Vue {

  biometricAuthStore = useBiometricAuthStore();
  notifierStore = useNotifierStore();

  @Prop()
  username: string;

  @Prop()
  password: string;

  @Prop()
  FailureRouteFunc: () => RawLocation;

  @Prop()
  routeToLogin: RawLocation;

  mounted () {
    if (!this.username || !this.password) {
      this.$router.push(this.FailureRouteFunc());
    }
    this.biometricAuthStore.loadBiometricSettings();
  }

  routeToLandingPage () {
    this.$router.push(this.routeToLogin);
  }

  setupBiometricAuth () {
    this.biometricAuthStore.enableBiometricAuth({
      username: this.username,
      password: this.password,
    }).then(result => {
      if (result) {
        this.notifierStore.setSuccess(this.biometricAuthStore.getBiometryType.displayValue + " setup completed successfully.");
        setTimeout(() => {
          this.routeToLandingPage();
        }, 1000);
        return;
      }
    })
      .catch(error => {
        this.notifierStore.setInfo(error.message);
      });
  }
}
